import 'requestidlecallback-polyfill';
// import { throttle } from 'lodash-es';
import { throttle } from '@/utils/lodashReplacement';
// 延迟安全引用：initStore, userStore, agentStore
import coreStore from '@/stores/core';
import { TRACKING_OPERATION } from '../constants';

import { EventInfo } from '../types';
import { reportAPI } from '@/services/report';
import { getChatbotApiQuery } from '@/services/request';
import { getChatbotHost } from '@/config/core';

interface ChatbotBIEventInfo {
  // {user_id}	用户id
  user_id?: string;
  chatbot_user_id?: string;
  // {is_login}	用户是否登录string;
  is_login?: boolean;
  // {chatbot_session_id}
  session_id?: string;
  // {liveagent_session_id}
  liveagent_session_id?: string;
  // chatbot_page	页面类型
  page_type?: string;
  section: EventInfo['page_section'];
  // 发生的timestamp
  time?: string;
  entry_point?: string;
  module?: EventInfo['target_type'];
  event?: TRACKING_OPERATION;
  ab_test?: string;
  data?: any;
}

// type RequestIdleCallbackHandle = any;
// type RequestIdleCallbackOptions = {
//   timeout: number;
// };
// type RequestIdleCallbackDeadline = {
//   readonly didTimeout: boolean;
//   timeRemaining: () => number;
// };

const FLUSH_SIZE = 20;
const THROTTLE_TIMEOUT = 3000;

/**
 * 这个类用于维护 tmc 上报相关的接口, 主要是针对接口做了暂存及节流消费的逻辑.
 */
export class ChatbotBITrack {
  dataList: ChatbotBIEventInfo[] = [];
  idleCallback: any;

  constructor() {
    this.tick();
  }

  /**
   * 这里维护了一个定时器来消费暂存起来的请求队列.
   * 利用 requestIdleCallback 检测浏览器是否进入空闲状态
   * 然后根据不同条件
   * 1. 满足节流要求
   * 2. 队列达到 FLUSH_SIZE
   * 来触发请求
   */
  tick = () => {
    this.idleCallback = window.requestIdleCallback(async () => {
      if (this.dataList.length >= FLUSH_SIZE) {
        // 立即上报, 不需要等待
        this.request();
      } else {
        this.requestByThrottle();
      }
      this.tick();
    });
  };

  /**
   * 埋点方法
   * 这里复用了 dispatchTrack 处理后的数据格式,
   * 其余的大部分参数都可以从 store 里获取.
   * @param {EventInfo} info
   * @memberof AppBITrack
   */
  report(info: EventInfo) {
    if (info.operation === 'action_hipo') {
      return;
    }

    const userStore = coreStore.safeGetStore('userStore');
    const agentStore = coreStore.safeGetStore('agentStore');
    const initStore = coreStore.safeGetStore('initStore');

    const data: ChatbotBIEventInfo = {
      user_id: userStore.userId || undefined,
      chatbot_user_id: userStore.chatbot_user_id || undefined,
      is_login: !!userStore.userId,
      liveagent_session_id: agentStore.sessionID,
      page_type: info.page_type,
      time: Date.now().toString(),
      entry_point: capitalizeFirstLetter(initStore.from ?? ''),
      section: info.page_section,
      module: info.target_type,
      event: info.operation,
      data: JSON.stringify(info.data),
      ab_test: userStore.abTestingSignature || undefined,
    };

    this.dataList.push(data);
  }

  flush() {
    navigator.sendBeacon(
      `${getChatbotHost()}/report/v1/trace?${getChatbotApiQuery()}`,
      JSON.stringify({ items: this.dataList }),
    );
  }

  /**
   *
   * @param length 需要上报的队列数, 默认为 FLUSH_SIZE
   */
  request = async (length = FLUSH_SIZE) => {
    if (!this.dataList.length) {
      return;
    }
    const initStore = coreStore.safeGetStore('initStore');
    const dataFrame = this.dataList.splice(0, length);
    // console.info('REQUEST', dataFrame.length, this.dataList.length);
    return await reportAPI.post('/trace', {
      items: dataFrame.map((data) => ({
        ...data,
        session_id: initStore.sessionId,
      })),
    });
  };

  requestByThrottle = throttle(this.request, THROTTLE_TIMEOUT, { leading: false });

  destroy() {
    window.cancelIdleCallback(this.idleCallback);
  }
}

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

